<div class="main-content-wrapper">
	<div class="main-content">
		<header class="main-content-header">
			<h1>Activity Logs &nbsp;&nbsp;&nbsp;<a href="javascript:" (click)="loadHistory()"><em class="fa fa-redo-alt" title="Refresh Activity Logs"></em></a></h1>
		</header>
	</div>
</div>
<div class="main-content-area" #mainContentArea>
	<div class="main-content-body" #leftContainer [ngClass]="{'loading in': loading}">
		<table class="full-width table table-striped table-fixed">
			<thead>
				<tr>
					<th id="date" class="title-cell" (click)="updateSort('date')">Date <em *ngIf="userSortCol == 'date' && !userSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="userSortCol == 'date' && userSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="name" class="title-cell" (click)="updateSort('name')">Name <em *ngIf="userSortCol == 'name' && !userSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="userSortCol == 'name' && userSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="user" (click)="updateSort('user')">User <em *ngIf="userSortCol == 'user' && !userSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="userSortCol == 'user' && userSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
					<th id="activityType" (click)="updateSort('activityType')">Action <em *ngIf="userSortCol == 'activityType' && !userSortAsc" class="fas fa-long-arrow-alt-up"></em><em *ngIf="userSortCol == 'activityType' && userSortAsc" class="fas fa-long-arrow-alt-down"></em></th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let log of getSortedFilteredHistory(); let i = index">
					<tr class="file-share">
						<td>{{ log.date | date : 'medium' }}</td>
						<td>{{ log.name }}</td>
						<td>{{ log.user }}</td>
						<td>{{ log.activityType }}</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>

</div>